import { Injectable } from '@angular/core';
import { DeviceHealthPresentation } from '../../equipment/devices/components/device-details/device-details-metrics/device-details-metrics.types';
import { DeviceHealthType } from '../../equipment/health-monitor/health-api.types';
import { ConsumptionResponse } from './consumption.types';

@Injectable({ providedIn: 'root' })
export class PreviousPeriodService {
  overlapAxisDeviceHealthChart(
    mainData: DeviceHealthPresentation,
    secondaryData: DeviceHealthPresentation
  ): DeviceHealthPresentation[] {
    if (!mainData || !mainData.health?.data) {
      return [mainData];
    }

    if (secondaryData?.health?.data) {
      const alignedSecondaryData = {
        ...secondaryData,
        health: {
          ...secondaryData.health,
          data: secondaryData.health.data.map((item, index) => ({
            ...item,
            x: mainData.health.data[index]?.x ?? item.x,
            optional: { ...item.optional, previousPeriod: item.x }
          }))
        }
      };
      return [mainData, alignedSecondaryData];
    }

    return [mainData];
  }
  prepareConsumptionData(consumptionResponse: ConsumptionResponse): DeviceHealthPresentation[] {
    const { currentPeriod, previousPeriod } = consumptionResponse;
    const healthAggregation = [
      {
        type: DeviceHealthType.Consumption,
        health: currentPeriod.data.find(datum => datum.y !== null && datum.x)
          ? currentPeriod
          : {
              type: DeviceHealthType.Consumption,
              unitOfMeasure: '',
              multiplier: '',
              data: []
            },
        config: []
      }
    ];
    if (previousPeriod) {
      healthAggregation.push({
        type: DeviceHealthType.PreviousConsumption,
        health: previousPeriod.data.find(datum => datum.y && datum.x)
          ? previousPeriod
          : {
              type: DeviceHealthType.PreviousConsumption,
              unitOfMeasure: '',
              multiplier: '',
              data: []
            },
        config: []
      });
    }
    return healthAggregation as DeviceHealthPresentation[];
  }
}
